import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn, ArrowLeft, Lock, User } from "lucide-react";
import { HeroBg } from "../components/Shared";
import { login, setToken, formatError } from "../lib/api";
import SEO from "../components/SEO";

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const data = await login(username, password);
      setToken(data.token);
      nav("/admin/dashboard");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <SEO
        title="Admin | SUV Engineers"
        description="SUV Engineers administrator dashboard login page."
      />
      <HeroBg />
      <div className="login-card" data-testid="admin-login-card">
        <img className="brand-logo" src="/assets/suvlogo.png" alt="SUV Engineers" style={{ filter: "brightness(0.1)" }} />
        <h1>Admin Login</h1>
        <p className="sub">Sign in to manage projects and site content.</p>
        {error && <div className="login-error" data-testid="login-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="field">
            <label><User size={14} style={{ verticalAlign: "-2px", marginRight: 6 }} />Username</label>
            <input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" required data-testid="login-username" />
          </div>
          <div className="field">
            <label><Lock size={14} style={{ verticalAlign: "-2px", marginRight: 6 }} />Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required data-testid="login-password" />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={busy} data-testid="login-submit">
            {busy ? "Signing in…" : <>Sign In <LogIn size={17} /></>}
          </button>
        </form>
        <Link to="/" className="login-back"><ArrowLeft size={15} /> Back to website</Link>
      </div>
    </div>
  );
}
